import ListsContainer from "../../../Components/UiKits/Lists/ListsContainer";

const Lists = () => {
  return <ListsContainer />;
};

export default Lists;
